import React from 'react';

import { useEffect } from 'react';

const CookiePolicyPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">מדיניות עוגיות (Cookie Policy)</h1>
          <p className="text-gray-700 text-center mb-6">עודכן לאחרונה: יולי 2025</p>

          <div className="prose prose-lg max-w-none" dir="rtl">
            <p className="text-gray-700 leading-relaxed mb-6">
              מסמך זה מהווה את מדיניות העוגיות של אתר "גמלנט AI" ("האתר", "אנחנו", "השירות") ומטרתו להסביר למשתמש ("המשתמש", "אתה") מהם קובצי העוגיות (Cookies), כיצד ומדוע אנו עושים בהם שימוש, מהן אפשרויותיך ביחס לשימוש זה, וכיצד תוכל לשלוט בו. מדיניות זו מהווה חלק בלתי נפרד ממדיניות הפרטיות ומהתנאים הכלליים של האתר.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. מהן עוגיות (Cookies)?</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              "עוגיות" הן קובצי טקסט קטנים שנשמרים בדפדפן המשתמש כאשר הוא מבקר באתר אינטרנט. העוגיות משמשות, בין היתר, לתפעול שוטף של האתר, לאיסוף נתוני שימוש, לשיפור חוויית המשתמש, להפקת סטטיסטיקות אנונימיות ולמטרות שיווקיות. ישנן עוגיות "זמניות" (Session Cookies) הנמחקות בתום ביקור באתר, וישנן עוגיות "קבועות" (Persistent Cookies) הנשמרות לפרק זמן מסוים.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. סוגי עוגיות באתר</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              האתר עושה שימוש בעוגיות הבאות או בטכנולוגיות דומות:
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">2.1. עוגיות תפעוליות חיוניות (Strictly Necessary Cookies)</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>נדרשות לצורך פעולה תקינה של האתר (למשל, ניווט, טעינת דפים, שמירת הגדרות בסיסיות)</li>
              <li>לא ניתן להשביתן דרך ממשק האתר.</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">2.2. עוגיות ביצועים וסטטיסטיקה (Performance & Analytics Cookies)</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>אוספות מידע על אופן השימוש באתר (למשל, עמודים נצפים, קליקים, זמן שהייה)</li>
              <li>מידע זה עוזר לנו לשפר את מבנה האתר, איתור תקלות, ופיתוח יכולות חדשות</li>
              <li>נעשה שימוש בכלים כגון:</li>
              <ul className="list-circle list-inside text-gray-700 space-y-2 pr-6">
                <li>Microsoft Clarity</li>
                <li>Hotjar</li>
                <li>Firebase Analytics</li>
              </ul>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">2.3. עוגיות מיקוד ושיווק (Targeting & Marketing Cookies) – (עתידי בלבד)</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>אינן מופעלות בשלב זה, אך ייתכן שיופעלו בהמשך לצורך הצגת תוכן ממוקד או ביצוע רימרקטינג.</li>
              <li>כל שימוש עתידי יהיה בהתאם לחוק התקשורת ובכפוף להסכמת המשתמש.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. מקורות צד שלישי</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              חלק מהעוגיות באתר מונחות על ידי צדדים שלישיים כגון Google, Microsoft, או ספקי אנליטיקה אחרים, והן כפופות למדיניות הפרטיות של אותם גופים. המשתמש מאשר כי השימוש באתר עשוי להוביל להעברת נתונים (כגון IP, מזהי מכשיר ודפדפן, נתוני שימוש אנונימיים) לגורמים אלו, בכפוף למנגנוני הגנה מקובלים.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. הסכמה לשימוש בעוגיות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>נכון למועד זה, מוצגת באתר הודעת Cookie עם אפשרות אישור. השימוש באתר לאחר הצגת ההודעה מהווה הסכמה מדעת לשימוש בעוגיות לפי מדיניות זו.</li>
              <li>יובהר כי הסכמה זו כוללת גם עוגיות צד שלישי וכלי ניתוח אנונימיים.</li>
              <li>במידה ויתווספו עוגיות חדשות מסוגים שדורשים הסכמה ייחודית (כגון פרסום ממוקד), תידרש הסכמה נפרדת ומפורשת.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. כיצד ניתן לשלוט בשימוש בעוגיות?</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              ניתן לשנות את הגדרות העוגיות בדרכים הבאות:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>דרך הגדרות הדפדפן – ניתן למחוק עוגיות קיימות, לחסום עוגיות עתידיות, או להגדיר התרעה על כל ניסיון להצבת עוגייה.</li>
              <li>דרך תוסף חוסם עוגיות (Browser Extension) – כגון Ghostery, Privacy Badger, uBlock Origin.</li>
              <li>דרך ממשק ההסכמה באתר – ככל שיופעל בעתיד מנגנון Cookie Management מובנה.</li>
            </ul>
            <div className="bg-yellow-50 border-r-4 border-yellow-400 p-4 mb-6">
              <p className="text-yellow-800">
                <strong>שים לב:</strong> חסימת עוגיות מסוימות עלולה לפגוע בתפקוד האתר, לגרום לתקלות, או להגביל את השירותים הניתנים.
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. שינויים במדיניות עוגיות</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              מפעיל האתר שומר לעצמו את הזכות לשנות, לעדכן או להרחיב את מדיניות העוגיות מעת לעת, לפי שיקול דעתו הבלעדי וללא הודעה מוקדמת. מדיניות מעודכנת תפורסם באתר ותיכנס לתוקף עם מועד פרסומה. המשך השימוש באתר לאחר עדכון המדיניות ייחשב כהסכמה מחודשת מצד המשתמש.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. יצירת קשר</h2>
            <p className="text-gray-700 leading-relaxed">
              בכל שאלה, בקשה או בירור הנוגע למדיניות העוגיות – ניתן לפנות אלינו דרך{' '}
              <a href="/contact" className="text-blue-600 hover:text-blue-800">טופס "צור קשר" באתר</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;